import { InteractionManager, Platform } from 'react-native';

interface InteractionHandle {
	cancel: () => void;
}

/**
 * Runs a callback once the UI has settled -- and on web, straight away.
 *
 * On native, waiting keeps a heavy screen from janking the transition that brought
 * you there. On web there is no such transition, and waiting costs correctness:
 * react-native-web schedules InteractionManager through `requestIdleCallback`, which
 * a browser does not run for a tab that is not in front. Measured on a background
 * tab: `visibilityState` is `hidden` and no callback arrives at all.
 *
 * A screen that gates its content on this therefore sat on its loader forever when a
 * shared link was opened in a new tab -- which is exactly how a link gets opened.
 */
export function afterInteractions(run: () => void): InteractionHandle {
	if (Platform.OS === 'web') {
		run();

		return { cancel: () => undefined };
	}

	const task = InteractionManager.runAfterInteractions(run);

	return { cancel: () => task.cancel() };
}

export default afterInteractions;
